/* EKNO shop-the-room — accessible hotspot popovers over a lifestyle image. */
(function () {
  'use strict';
  class EknoShopTheRoom extends HTMLElement {
    connectedCallback() {
      this.hotspots = Array.from(this.querySelectorAll('[data-hotspot]'));
      const closeAll = (except) => this.hotspots.forEach((h) => { if (h !== except) this.set(h, false); });
      this.hotspots.forEach((h) => {
        const btn = h.querySelector('[data-hotspot-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => { const open = btn.getAttribute('aria-expanded') === 'true'; closeAll(h); this.set(h, !open); });
        h.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.set(h, false); btn.focus(); } });
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) closeAll(); });
      // Hint disappears after first interaction
      this.addEventListener('click', () => this.querySelector('.shop-room__hint')?.setAttribute('hidden', ''), { once: true });
    }
    set(h, open) {
      const btn = h.querySelector('[data-hotspot-toggle]'); const card = h.querySelector('.hotspot__card');
      if (!btn || !card) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      card.classList.toggle('is-open', open);
      if (open) {
        // Keep the card inside the stage on desktop
        const stage = this.getBoundingClientRect(); const rect = card.getBoundingClientRect();
        if (rect.right > stage.right - 8) { h.classList.add('hotspot--end'); h.classList.remove('hotspot--start'); }
        else if (rect.left < stage.left + 8) { h.classList.add('hotspot--start'); h.classList.remove('hotspot--end'); }
        if (rect.bottom > window.innerHeight - 8) h.classList.add('hotspot--flip');
        card.querySelector('a, button')?.focus({ preventScroll: true });
      }
    }
  }
  customElements.define('ekno-shop-the-room', EknoShopTheRoom);
})();
